import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import TravelApplication from '@/types/table/travelApplication';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface TravelApplicationData extends TravelApplication {
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class TravelApplicationController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<TravelApplicationData>>(API_CONTEXT + '/upms/travelApplication/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<TravelApplicationData>(API_CONTEXT + '/upms/travelApplication/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/upms/travelApplication/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/upms/travelApplication/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/upms/travelApplication/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/travelApplication/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/travelApplication/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/travelApplication/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/travelApplication/deleteBatch', params, httpOptions);
  }
  static startOnlyTravelApplicationFlow(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/travelApplication/startOnly/travelApplicationFlow', params, httpOptions);
  }
  static startWithBusinessKeyTravelApplicationFlow(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/travelApplication/startWithBusinessKey/travelApplicationFlow', params, httpOptions);
  }
  static startAndTakeUserTaskTravelApplicationFlow(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/travelApplication/startAndTakeUserTask/travelApplicationFlow', params, httpOptions);
  }
  static startAndSaveDraftTravelApplicationFlow(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/travelApplication/startAndSaveDraft/travelApplicationFlow', params, httpOptions);
  }
  static submitUserTaskTravelApplicationFlow(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/travelApplication/submitUserTask/travelApplicationFlow', params, httpOptions);
  }
  static viewTaskBusinessDataTravelApplicationFlow(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(API_CONTEXT + '/upms/travelApplication/viewTaskBusinessData/travelApplicationFlow', params, httpOptions);
  }
  static viewHistoricTaskBusinessDataTravelApplicationFlow(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(API_CONTEXT + '/upms/travelApplication/viewHistoricTaskBusinessData/travelApplicationFlow', params, httpOptions);
  }
  static listWorkOrderTravelApplicationFlow(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/travelApplication/listWorkOrder/travelApplicationFlow', params, httpOptions);
  }
}
